import * as z from "zod";

export const TypeWellPerformanceRequestSchema = z.object({
  typeWellIds: z.array(z.string()),
  fields: z.array(z.string())
});

export const TypeWellPerformanceResponseSchema = z.record(
  z.string(),
  z.record(z.string(), z.number().nullable())
);

export const TypeWellPerformancePointSchema = z.object({
  typeWellId: z.string(),
  typeWellName: z.string(),
  xValue: z.number().nullable(),
  yValue: z.number().nullable()
});

export type TypeWellPerformanceRequestSchemaType = z.infer<
  typeof TypeWellPerformanceRequestSchema
>;
export type TypeWellPerformanceResponseSchemaType = z.infer<
  typeof TypeWellPerformanceResponseSchema
>;
export type TypeWellPerformancePointSchemaType = z.infer<
  typeof TypeWellPerformancePointSchema
>;
